import { render } from "./ContentMain.vue?vue&type=template&id=67c5b747"
import script from "./ContentMain.vue?vue&type=script&lang=js"
export * from "./ContentMain.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__